// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZnPFP","colBig":"styles_colBig__2qFmF","colSmall":"styles_colSmall__3V9VW","shopifyNameWrapper":"styles_shopifyNameWrapper__3eEa7"};